import { DateTime } from 'luxon';
import { SettingsState } from '@/store';

export function addUTCOffset(value: string): string {
    // TODO: avoid such behavior?
    if (!value) {
        return '';
    }

    const offset = SettingsState.contextSettings.global.timeOffset || 0;
    const offsetSign = offset >= 0 ? '+' : '';

    const valueDate = new Date(value).toISOString();
    return DateTime
                .fromISO(valueDate, { zone: 'UTC' + offsetSign + offset }).toString().replace('Z', '');
}

export function formatDate(value: string | Date, onlyDate: boolean = false, useFormat: boolean = true): string {
    // TODO: avoid such behavior?
    if (!value) {
        return '';
    }

    const dateTime = value instanceof Date ? value.toISOString() : new Date(value).toISOString();
    const offset = SettingsState.contextSettings.global.timeOffset || 0;
    const offsetSign = offset >= 0 ? '+' : '';

    const shortFormat = useFormat ? SettingsState.contextSettings.global.formatDate || 'yyyy-MM-dd' : 'yyyy-MM-dd';
    const timeFormat = useFormat ? SettingsState.contextSettings.global.formatTime || 'HH:mm' : 'HH:mm';
    const longFormat = shortFormat + ' ' + timeFormat;
    const format = onlyDate ? shortFormat : longFormat;

    const result = DateTime
        .fromISO(dateTime, { zone: 'UTC' + offsetSign + offset })
        .toFormat(format);
    return result;
}
